import {
  Box,
  Typography,
  Button,
  Paper,
  Stack,
} from "@mui/material";
import LockIcon from "@mui/icons-material/Lock";
import { useNavigate } from "react-router-dom";

export default function SubscribeRequired() {
  const navigate = useNavigate();

  return (
    <Box
      minHeight="70vh"
      display="flex"
      justifyContent="center"
      alignItems="center"
      px={2}
    >
      <Paper
        elevation={3}
        sx={{
          maxWidth: 520,
          p: 4,
          textAlign: "center",
          borderRadius: 4,
        }}
      >
        <LockIcon sx={{ fontSize: 64, color: "primary.main", mb: 1 }} />

        <Typography variant="h5" fontWeight={800} gutterBottom>
          Unlock Premium Learning 🚀
        </Typography>

        <Typography color="text.secondary" mb={3}>
          This feature is available to subscribed students.
          Upgrade your plan to continue enjoying uninterrupted practice,
          detailed results, and exam simulations.
        </Typography>

        <Stack spacing={2}>
          <Button
            variant="contained"
            size="large"
            onClick={() => navigate("/dashboard/pricing")}
            sx={{ fontWeight: 700 }}
          >
            View Subscription Plans
          </Button>

          <Button
            variant="outlined"
            onClick={() => navigate("/dashboard")}
          >
            Back to Dashboard
          </Button>
        </Stack>

        <Typography
          variant="caption"
          display="block"
          mt={3}
          color="text.secondary"
        >
          💡 Already subscribed? Please log out and log back in to refresh your session.
        </Typography>
      </Paper>
    </Box>
  );
}
